var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlojamientoNube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 144h-6a88.015 88.015 0 0 0 -156.988-78.066 75.993 75.993 0 0 0 -122.334 78.066h-2.678a56 56 0 0 0 -56 56 56 56 0 0 0 56 56h288a56 56 0 0 0 56-56 56 56 0 0 0 -56-56z",
    fill: "#85ccd5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#348ed8",
    height: 200,
    rx: 16,
    width: 176,
    x: 168,
    y: 96
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#459ce5",
    height: 72,
    rx: 16,
    width: 176,
    x: 168,
    y: 96
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 216v22.62a23.6 23.6 0 0 1 -8 1.38h-160a23.6 23.6 0 0 1 -8-1.38v-22.62a8.011 8.011 0 0 0 8 8h160a8.011 8.011 0 0 0 8-8z",
    fill: "#2d7dbe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 336h-176v-16h-16v16h-176a8 8 0 0 0 -8 8v24h16v-16h168v16h16v-16h168v16h16v-24a8 8 0 0 0 -8-8z",
    fill: "#85ccd5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 192h96v16h-96z",
    fill: "#2d7dbe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 192h16v16h-16z",
    fill: "#4db6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 256h16v16h-16z",
    fill: "#4db6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 256h96v16h-96z",
    fill: "#2d7dbe"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#348ed8",
    height: 64,
    rx: 8,
    width: 96,
    x: 24,
    y: 392
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 488h-48l8-32h32z",
    fill: "#d5d5d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 480h64v16h-64z",
    fill: "#dfdfdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92 472h-40l4-16h32z",
    fill: "#cececc"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#348ed8",
    height: 64,
    rx: 8,
    width: 96,
    x: 208,
    y: 392
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280 488h-48l8-32h32z",
    fill: "#d5d5d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 480h64v16h-64z",
    fill: "#dfdfdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276 472h-40l4-16h32z",
    fill: "#cececc"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#348ed8",
    height: 64,
    rx: 8,
    width: 96,
    x: 392,
    y: 392
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464 488h-48l8-32h32z",
    fill: "#d5d5d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 480h64v16h-64z",
    fill: "#dfdfdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460 472h-40l4-16h32z",
    fill: "#cececc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlojamientoNube);
export default __webpack_public_path__ + "static/media/alojamiento_nube.49f6c57a7724e127aa354a3937bb53a3.svg";
export { ForwardRef as ReactComponent };